import { defineMessages } from 'react-intl';

export const messages: {
	feedbackTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	enrolInResearchLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	canBeContactedLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	canBeContactedLabelWithoutLink: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	privacyPolicy: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	summaryPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	formCommentLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	submitButtonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	cancelButtonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	giveFeedback: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	formBugLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	formSuggestionLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	formQuestionLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	formEmptyLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	formNotRelevantLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	formNotAccurateLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	formTooSlowLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	formUnhelpfulLinksLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	formOtherLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	selectionOptionQuestionLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	selectionOptionCommentLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	selectionOptionBugLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	selectionOptionSuggestionLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	selectionOptionDefaultLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	selectionOptionDefaultPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	feedbackIconLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	feedbackSuccessFlagDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	feedbackSuccessFlagTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	feedbackIsAnonymousTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	feedbackIsAnonymous: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	requiredFieldsSummary: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	defaultCustomTextAreaLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	canBeContactedLabelAppify: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	canBeContactedLabelAppifyWithoutLink: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	feedbackSuccessFlagDescriptionAppify: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	validationErrorTypeRequired: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	validationErrorDescriptionRequired: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	optInOptionsLegend: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	feedbackTitle: {
		id: 'feedback-collector.feedback-title',
		defaultMessage: 'Share your thoughts',
		description:
			'The title shown at the top of the feedback form encouraging users to leave feedback',
	},
	enrolInResearchLabel: {
		id: 'feedback-collector.enrol-in-research.label',
		defaultMessage: "I'd like to participate in product research",
		description:
			'The checkbox label letting users enrol themselves in future product research interviews',
	},
	canBeContactedLabel: {
		id: 'feedback-collector.can-be-contacted.label',
		defaultMessage:
			'Yes, Atlassian teams can contact me to learn about my experiences to improve Atlassian products and services. I acknowledge the <a>Atlassian Privacy Policy</a>.',
		description: 'The checkbox label to give consent to be contacted about their feedback',
	},
	canBeContactedLabelWithoutLink: {
		id: 'feedback-collector.can-be-contacted.label-without-link',
		defaultMessage:
			'Yes, Atlassian teams can contact me to learn about my experiences to improve Atlassian products and services. I acknowledge the Atlassian Privacy Policy.',
		description: 'The checkbox label to give consent to be contacted about their feedback',
	},
	privacyPolicy: {
		id: 'feedback-collector.privacy-policy',
		defaultMessage: 'Atlassian Privacy Policy',
		description: 'The text content for the Privacy Policy link',
	},
	summaryPlaceholder: {
		id: 'feedback-collector.summary-placeholder',
		defaultMessage: "Let us know what's on your mind",
		description:
			'The textarea label listing feedback categories (bug, suggestions, questions, comments)',
	},
	formCommentLabel: {
		id: 'feedback-collector.form.comment.label',
		defaultMessage: "Let us know what's on your mind",
		description: 'The textarea label where users can write their comment',
	},
	submitButtonLabel: {
		id: 'feedback-collector.submit-button.label',
		defaultMessage: 'Send feedback',
		description:
			"The text is shown on a primary submit button at the bottom of the feedback collector form. When clicked, it submits the user's feedback to Atlassian.",
	},
	cancelButtonLabel: {
		id: 'feedback-collector.cancel-button.label',
		defaultMessage: 'Cancel',
		description: 'The button to cancel feedback submission',
	},
	giveFeedback: {
		id: 'proforma-form-builder.give-feedback',
		defaultMessage: 'Give feedback',
		description: 'The button that allows users to give feedback',
	},
	formBugLabel: {
		id: 'feedback-collector.form.bug.label',
		defaultMessage: 'Describe the bug or issue',
		description: 'The textarea label where users can describe the bug or issue they have',
	},
	formSuggestionLabel: {
		id: 'feedback-collector.form.suggestion.label',
		defaultMessage: "Let us know what you'd like to improve",
		description: 'The textarea label where users can write their suggestion',
	},
	formQuestionLabel: {
		id: 'feedback-collector.form.question.label',
		defaultMessage: 'What would you like to know?',
		description: 'The textarea label where users can write their question',
	},
	formEmptyLabel: {
		id: 'feedback-collector.form.empty.label',
		defaultMessage: 'Select an option',
		description:
			'The text is shown as the default empty/placeholder option in the feedback type drop-down list when no option has been selected yet.',
	},
	formNotRelevantLabel: {
		id: 'feedback-collector.form.not-relevant.label',
		defaultMessage: "Wasn't relevant",
		description: 'The textarea label where users can write their not relevant feedback',
	},
	formNotAccurateLabel: {
		id: 'feedback-collector.form.not-accurate.label',
		defaultMessage: "Wasn't accurate",
		description: 'The textarea label where users can write their not accurate feedback',
	},
	formTooSlowLabel: {
		id: 'feedback-collector.form.too-slow.label',
		defaultMessage: 'Too slow',
		description: 'The textarea label where users can write their too slow feedback',
	},
	formUnhelpfulLinksLabel: {
		id: 'feedback-collector.form.unhelpful-links.label',
		defaultMessage: 'Unhelpful links',
		description: 'The textarea label where users can write their unhelpful links feedback',
	},
	formOtherLabel: {
		id: 'feedback-collector.form.other.label',
		defaultMessage: 'Other',
		description: 'The textarea label where users can write their other feedback',
	},
	selectionOptionQuestionLabel: {
		id: 'feedback-collector.option.question.label',
		defaultMessage: 'Ask a question',
		description: 'The feedback dropdown list option to ask a question',
	},
	selectionOptionCommentLabel: {
		id: 'feedback-collector.option.comment.label',
		defaultMessage: 'Leave a comment',
		description: 'The feedback dropdown list option to leave a comment',
	},
	selectionOptionBugLabel: {
		id: 'feedback-collector.option.bug.label',
		defaultMessage: 'Report a bug',
		description: 'The feedback dropdown list option to report a bug',
	},
	selectionOptionSuggestionLabel: {
		id: 'feedback-collector.option.suggestion.label',
		defaultMessage: 'Suggest an improvement',
		description: 'The feedback dropdown list option to suggest an improvement',
	},
	selectionOptionDefaultLabel: {
		id: 'feedback-collector.option.default.label',
		defaultMessage: 'Select feedback',
		description:
			'The text is shown as the visible label of the feedback type drop-down selector in the feedback collector form, prompting the user to choose a feedback category.',
	},
	selectionOptionDefaultPlaceholder: {
		id: 'feedback-collector.option.default.placeholder',
		defaultMessage: 'Choose one',
		description:
			'The text is shown as the placeholder inside the feedback type drop-down selector before the user makes a selection, prompting them to pick one of the available feedback categories.',
	},
	feedbackIconLabel: {
		id: 'proforma-form-builder.feedback-icon-label',
		defaultMessage: 'Feedback',
		description: 'Accessibility text used for the feedback icon',
	},
	feedbackSuccessFlagDescription: {
		id: 'feedback-collector.success-flag.description',
		defaultMessage: 'Your valuable feedback helps us continually improve our products.',
		description: 'Description shown when feedback is successfully submitted',
	},
	feedbackSuccessFlagTitle: {
		id: 'feedback-collector.success-flag.title',
		defaultMessage: 'Thanks!',
		description: 'Button to dismiss successflag flag after submitting feedback',
	},
	feedbackIsAnonymousTitle: {
		id: 'feedback-collector.anonymous.title',
		defaultMessage: 'Anonymous feedback',
		description: 'Section message title for anonymous feedback',
	},
	feedbackIsAnonymous: {
		id: 'feedback-collector.anonymous',
		defaultMessage:
			'This feedback is being submitted anonymously. Atlassian will not be able to contact you directly regarding this feedback',
		description:
			'The text is shown as an informational notice in the feedback collector form when the user is submitting feedback anonymously, informing them that Atlassian will not be able to follow up with them directly.',
	},
	requiredFieldsSummary: {
		id: 'feedback-collector.required.fields.summary',
		defaultMessage: 'Required fields are marked with an asterisk',
		description: 'Summary info of required fields asterisk.',
	},
	defaultCustomTextAreaLabel: {
		id: 'feedback-collector.default.custom.textarea.label',
		defaultMessage: "What's on your mind?",
		description:
			'The textarea label where users can write their suggestion for custom feedback collector',
	},
	canBeContactedLabelAppify: {
		id: 'feedback-collector.can-be-contacted.label-appify',
		defaultMessage:
			'Yes, Atlassian teams can contact me to learn about my experiences to improve Atlassian apps and services. I acknowledge the <a>Atlassian Privacy Policy</a>.',
		description: 'The checkbox label to give consent to be contacted about their feedback',
	},
	canBeContactedLabelAppifyWithoutLink: {
		id: 'feedback-collector.can-be-contacted.label-appify-without-link',
		defaultMessage:
			'Yes, Atlassian teams can contact me to learn about my experiences to improve Atlassian apps and services. I acknowledge the Atlassian Privacy Policy.',
		description: 'The checkbox label to give consent to be contacted about their feedback',
	},
	feedbackSuccessFlagDescriptionAppify: {
		id: 'feedback-collector.success-flag.description-appify',
		defaultMessage: 'Your valuable feedback helps us continually improve our apps.',
		description: 'Description shown when feedback is successfully submitted',
	},
	validationErrorTypeRequired: {
		id: 'feedback-collector.validation.type.required',
		defaultMessage: 'Please select a feedback type',
		description: 'Error message when feedback type is not selected',
	},
	validationErrorDescriptionRequired: {
		id: 'feedback-collector.validation.description.required',
		defaultMessage: 'Please provide a description',
		description: 'Error message when description is not provided',
	},
	optInOptionsLegend: {
		id: 'feedback-collector.opt-in.options.legend',
		defaultMessage: 'Atlassian opt-in options',
		description: 'Legend for the opt-in options on the feedback form',
	},
});
